import {
    allFetch,
} from "../Domain";

/**
 * @description 鈑烤設定
 */
export const PanelPaintSetting = (() => {


    // 金額等級

    /**
     * 新增金額等級
     * @param {*} price_start 金額起
     * @param {*} price_end 金額迄
     * @param {*} severe_level 重大維修等級
     * @returns 
     */
    const PanelPaintPriceLevelCreate = async function (obj = {
        price_start: '',
        price_end: '',
        severe_level: ''
    }) {
        return await allFetch('PanelPaintSetting/PanelPaintPriceLevelCreate', obj);
    }

    /**
     * 修改金額等級
     * @param {*} pppl_id 流水號
     * @param {*} price_start 金額起
     * @param {*} price_end 金額迄
     * @param {*} severe_level 重大維修等級
     * @param {*} visible 是否可見
     * @returns 
     */
    const PanelPaintPriceLevelUpdate = async function (obj = {
        pppl_id: '',
        price_start: '',
        price_end: '',
        severe_level: '',
        visible: ''
    }) {
        return await allFetch('PanelPaintSetting/PanelPaintPriceLevelUpdate', obj);
    }

    /**
     * 查詢金額等級
     * @param {*} visible 是否可見
     * @param {*} page 頁碼
     * @param {*} num_per_page 一頁幾筆
     * @returns 
     */
    const PanelPaintPriceLevelSearch = async function (obj = {
        visible: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('PanelPaintSetting/PanelPaintPriceLevelSearch', obj);
    }

    /**
     * 金額等級細項
     * @param {*} pppl_id 流水號
     * @returns 
     */
    const PanelPaintPriceLevelDetail = async function (obj = {
        pppl_id: ""
    }) {
        return await allFetch('PanelPaintSetting/PanelPaintPriceLevelDetail', obj);
    }

    /**
     * 刪除金額等級
     * @param {*} pppl_id 流水號
     * @returns 
     */
    const PanelPaintPriceLevelDelete = async function (obj = {
        pppl_id: ""
    }) {
        return await allFetch('PanelPaintSetting/PanelPaintPriceLevelDelete', obj);
    }


    // 狀態標籤

    /**
     * 新增狀態標籤
     * @param {*} label_big 第一層流水號
     * @param {*} label_mid 第二層流水號
     * @param {*} content 名稱
     * @param {*} seq 排序
     * @returns 
     */
    const PanelPaintStatusLabelCreate = async function (obj = {
        label_big: '',
        label_mid: '',
        content: '',
        seq: ''
    }) {
        return await allFetch('PanelPaintSetting/PanelPaintStatusLabelCreate', obj);
    }

    /**
     * 修改狀態標籤
     * @param {*} ppsl_id 狀態標籤流水號
     * @param {*} label_big 第一層流水號
     * @param {*} label_mid 第二層流水號
     * @param {*} content 名稱
     * @param {*} seq 排序
     * @param {*} visible 是否可見
     * @returns 
     */
    const PanelPaintStatusLabelUpdate = async function (obj = {
        ppsl_id: '',
        label_big: '',
        label_mid: '',
        content: '',
        seq: '',
        visible: ''
    }) {
        return await allFetch('PanelPaintSetting/PanelPaintStatusLabelUpdate', obj);
    }

    /**
     * 查詢狀態標籤
     * @param {*} label_big 第一層流水號
     * @param {*} label_mid 第二層流水號
     * @param {*} content 名稱
     * @param {*} visible 是否可見
     * @returns 
     */
    const PanelPaintStatusLabelSearch = async function (obj = {
        label_big: '',
        label_mid: '',
        content: '',
        visible: ''
    }) {
        return await allFetch('PanelPaintSetting/PanelPaintStatusLabelSearch', obj);
    }

    /**
     * 狀態標籤細項
     * @param {*} ppsl_id 狀態標籤流水號
     * @returns 
     */
    const PanelPaintStatusLabelDetail = async function (obj = {
        ppsl_id: ''
    }) {
        return await allFetch('PanelPaintSetting/PanelPaintStatusLabelDetail', obj);
    }

    /**
     * 刪除狀態標籤
     * @param {*} ppsl_id 狀態標籤流水號
     * @returns 
     */
    const PanelPaintStatusLabelDelete = async function (obj = {
        ppsl_id: ''
    }) {
        return await allFetch('PanelPaintSetting/PanelPaintStatusLabelDelete', obj);
    }


    return {
        PanelPaintPriceLevelCreate,
        PanelPaintPriceLevelUpdate,
        PanelPaintPriceLevelSearch,
        PanelPaintPriceLevelDetail,
        PanelPaintPriceLevelDelete,
        PanelPaintStatusLabelCreate,
        PanelPaintStatusLabelUpdate,
        PanelPaintStatusLabelSearch,
        PanelPaintStatusLabelDetail,
        PanelPaintStatusLabelDelete,
    }
})();